<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-btn
          text
          @click="$router.go(-1)"
          class="mb-4"
        >
          <v-icon left>mdi-arrow-left</v-icon>
          Zurück
        </v-btn>
        <v-card v-if="bankAccount">
          <v-card-title>
            Bankverbindung bearbeiten: {{ bankAccount.name }}
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="bankAccount.name"
                    label="Name"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="bankAccount.iban"
                    label="IBAN"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="bankAccount.description"
                    label="Beschreibung"
                    rows="3"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-switch
                    v-model="bankAccount.active"
                    label="Aktiv"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="6">
                  <v-switch
                    v-model="bankAccount.ignore_for_processing"
                    label="Nicht verarbeiten"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!valid || saving"
              :loading="saving"
              @click="save"
            >
              Speichern
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-alert v-else-if="error" type="error">
          {{ error }}
        </v-alert>
        <v-progress-linear v-else indeterminate color="primary"></v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { GET_TENANTS } from '@/modules/kirchgeld/store/kirchgeld/action-types'

export default {
  name: 'BankAccountDetail',
  data () {
    return {
      bankAccount: null,
      error: null,
      valid: false,
      saving: false,
      rules: {
        required: value => !!value || 'Pflichtfeld',
      }
    }
  },
  computed: {
    bankAccountId () {
      return this.$route.params['bank-account-id'] || null
    }
  },
  methods: {
    async fetchBankAccount () {
      try {
        this.bankAccount = null

        await this.$store.dispatch('kirchgeld/' + GET_TENANTS)
        const tenantUrl = this.$store.state.kirchgeld.tenant.url
        const accountId = this.bankAccountId
        const response = await this.$store.getters['kirchgeld/api'].get(`${tenantUrl}bank_account/${accountId}/`)
        this.bankAccount = response.data
      } catch (e) {
        this.error = 'Bankverbindung konnte nicht geladen werden.'
        // eslint-disable-next-line
        console.error(e)
      }
    },
    async save () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.saving = true
      try {
        await this.$store.dispatch('kirchgeld/' + GET_TENANTS)
        const tenantUrl = this.$store.state.kirchgeld.tenant.url
        const accountId = this.bankAccountId
        await this.$store.getters['kirchgeld/api'].patch(
          `${tenantUrl}bank_account/${accountId}/`,
          {
            name: this.bankAccount.name,
            iban: this.bankAccount.iban,
            description: this.bankAccount.description,
            active: this.bankAccount.active,
            ignore_for_processing: this.bankAccount.ignore_for_processing,
          }
        )
        this.$router.push({ name: 'kige-bank-account-list' })
      } catch (e) {
        this.error = 'Bankverbindung konnte nicht gespeichert werden.'
        // eslint-disable-next-line
        console.error(e)
      } finally {
        this.saving = false
      }
    }
  },
  watch: {
    bankAccountId: {
      immediate: true,
      async handler (newVal) {
        if (newVal) {
          await this.fetchBankAccount()
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
